import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API_ROOT = `${BACKEND_URL}/api`;

const api = axios.create({
  baseURL: API_ROOT,
  withCredentials: true,
});

// Silent session renewal: on a 401, refresh once (shared across concurrent calls) and retry.
const NO_RETRY = ["/auth/refresh", "/auth/login", "/auth/logout", "/auth/otp/"];
let refreshing = null;
api.interceptors.response.use(
  (r) => r,
  async (error) => {
    const cfg = error.config;
    if (error.response?.status !== 401 || !cfg || cfg._retried || NO_RETRY.some((p) => cfg.url?.includes(p))) throw error;
    cfg._retried = true;
    refreshing = refreshing || api.post("/auth/refresh").finally(() => { setTimeout(() => { refreshing = null; }, 1000); });
    try { await refreshing; } catch { throw error; }
    return api(cfg);
  },
);

export function formatApiErrorDetail(detail) {
  if (detail == null) return "Something went wrong. Please try again.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail.map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e))).filter(Boolean).join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}

export function apiError(e) {
  return formatApiErrorDetail(e?.response?.data?.detail) || e?.message || "Request failed";
}

export default api;
